
      if (import.meta.env.PROD) {
        let shouldLoad = true;
        try {
          const settings = localStorage.getItem('syto-ux-settings');
          if (settings) {
            const parsed = JSON.parse(settings);
            if (parsed.analyticsOptOut === true) shouldLoad = false;
          }
        } catch (e) {}
        if (shouldLoad) {
          const script = document.createElement('script');
          script.setAttribute('data-goatcounter', 'https://syto.goatcounter.com/count');
          script.async = true;
          script.src = '//gc.zgo.at/count.js';
          document.head.appendChild(script);
        }
      }
    